import { Title, type TitleProps } from '@mantine/core';
import type { ReactNode } from 'react';

export const DrawerSectionTitle = ({
  children,
  ...props
}: { children: ReactNode } & TitleProps) => (
  <Title order={4} mt="xl" mb="xs" {...props}>
    {children}
  </Title>
);
